/* eslint-disable perfectionist/sort-objects */
export const dealershipListColumns = {
	displayName: 400,
	partnerNumber: 250,
	organisationFunction: 250,
	country: 150,
	chooseLanguage: 200,
}
